var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-header-index-wide" },
    [
      _c(
        "a-button",
        {
          staticStyle: { "margin-bottom": "3px" },
          attrs: { type: "primary" },
          on: { click: _vm.refreshData }
        },
        [_vm._v(_vm._s(_vm.language["common.refresh"]))]
      ),
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            {
              style: { marginBottom: "24px" },
              attrs: { sm: 24, md: 12, xl: 6 }
            },
            [
              _c(
                "a-card",
                {
                  attrs: {
                    title: _vm.language["emp.home.totalUser"] + ":",
                    bordered: false,
                    "body-style": { padding: "20px 24px 8px" }
                  }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { slot: "extra" },
                      on: { click: _vm.toUserList },
                      slot: "extra"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "800",
                            "font-size": "large",
                            color: "white"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.userCountInfo.totalNum) +
                              " " +
                              _vm._s(_vm.language["emp.home.people"]) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.language["emp.home.newUserToday"]) + ":  "
                      )
                    ]),
                    _c(
                      "span",
                      { staticStyle: { "font-weight": "600", color: "red" } },
                      [_vm._v("+" + _vm._s(_vm.userCountInfo.todayNewNum))]
                    )
                  ]),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.language["emp.home.todayVisit"]) +
                          ":  " +
                          _vm._s(_vm.userCountInfo.todayVisitNum) +
                          " "
                      )
                    ]),
                    _c(
                      "span",
                      { staticStyle: { "font-weight": "600", color: "red" } },
                      [
                        _vm._v(
                          "  (" + _vm._s(_vm.language["emp.home.compareYest"])
                        )
                      ]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.userCountInfo.compareYesterdayNum > 0,
                            expression: "userCountInfo.compareYesterdayNum>0"
                          }
                        ],
                        staticStyle: { "font-weight": "600", color: "red" }
                      },
                      [_vm._v("+")]
                    ),
                    _c(
                      "span",
                      { staticStyle: { "font-weight": "600", color: "red" } },
                      [
                        _vm._v(
                          _vm._s(_vm.userCountInfo.compareYesterdayNum) + ")"
                        )
                      ]
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { marginBottom: "24px" },
              attrs: { sm: 24, md: 12, xl: 6 }
            },
            [
              _c(
                "a-card",
                {
                  attrs: {
                    title: _vm.language["emp.home.allContentNumber"] + ":",
                    bordered: false,
                    "body-style": { padding: "20px 24px 8px" }
                  }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { slot: "extra" },
                      on: { click: _vm.toContent },
                      slot: "extra"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "800",
                            "font-size": "large",
                            color: "white"
                          }
                        },
                        [_vm._v(_vm._s(_vm.contentAllNumber))]
                      )
                    ]
                  ),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.language["emp.home.bulletinBoard"]) +
                          ":  " +
                          _vm._s(_vm.bulletinBoardContentNumber)
                      )
                    ]),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.bulletinBoardTodayContentNumber > 0,
                            expression: "bulletinBoardTodayContentNumber>0"
                          }
                        ],
                        staticStyle: { "font-weight": "600", color: "red" }
                      },
                      [
                        _vm._v(
                          "   ( " +
                            _vm._s(_vm.language["emp.home.today"]) +
                            ":+" +
                            _vm._s(_vm.bulletinBoardTodayContentNumber) +
                            " )"
                        )
                      ]
                    )
                  ]),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.language["emp.home.personnelAnnouncement"]) +
                          ":  " +
                          _vm._s(_vm.personnelAnnouncementContentNumber)
                      )
                    ]),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.personnelAnnouncementTodayContentNumber > 0,
                            expression:
                              "personnelAnnouncementTodayContentNumber>0"
                          }
                        ],
                        staticStyle: { "font-weight": "600", color: "red" }
                      },
                      [
                        _vm._v(
                          "   ( " +
                            _vm._s(_vm.language["emp.home.today"]) +
                            ":+" +
                            _vm._s(
                              _vm.personnelAnnouncementTodayContentNumber
                            ) +
                            " )"
                        )
                      ]
                    )
                  ]),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.language["emp.home.managementMeasuresZone"]
                        ) +
                          ":  " +
                          _vm._s(_vm.managementMeasuresZoneContentNumber)
                      )
                    ]),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.managementMeasuresZoneTodayContentNumber > 0,
                            expression:
                              "managementMeasuresZoneTodayContentNumber>0"
                          }
                        ],
                        staticStyle: { "font-weight": "600", color: "red" }
                      },
                      [
                        _vm._v(
                          "   ( " +
                            _vm._s(_vm.language["emp.home.today"]) +
                            ":+" +
                            _vm._s(
                              _vm.managementMeasuresZoneTodayContentNumber
                            ) +
                            " )"
                        )
                      ]
                    )
                  ]),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.language["emp.home.educationTrainingZone"]) +
                          ":  " +
                          _vm._s(_vm.educationTrainingZoneContentNumber)
                      )
                    ]),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.educationTrainingZoneTodayContentNumber > 0,
                            expression:
                              "educationTrainingZoneTodayContentNumber>0"
                          }
                        ],
                        staticStyle: { "font-weight": "600", color: "red" }
                      },
                      [
                        _vm._v(
                          "   ( " +
                            _vm._s(_vm.language["emp.home.today"]) +
                            ":+" +
                            _vm._s(
                              _vm.educationTrainingZoneTodayContentNumber
                            ) +
                            " )"
                        )
                      ]
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { marginBottom: "24px" },
              attrs: { sm: 24, md: 12, xl: 6 }
            },
            [
              _c(
                "a-card",
                {
                  attrs: {
                    title: _vm.language["emp.home.totalApps"] + ":",
                    bordered: false,
                    "body-style": {
                      padding: "20px 24px 8px",
                      overflowY: "auto",
                      height: "290px"
                    }
                  }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { slot: "extra" },
                      on: { click: _vm.toApplicationList },
                      slot: "extra"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "800",
                            "font-size": "large",
                            color: "white"
                          }
                        },
                        [_vm._v(_vm._s(_vm.appStatInfo.totalNum))]
                      )
                    ]
                  ),
                  _vm._l(_vm.appStatInfo.appTypeStatList, function(item, i) {
                    return _c(
                      "p",
                      { key: i, attrs: { value: item.appTypeCode } },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(item.appTypeName) +
                              ":  " +
                              _vm._s(item.applicationNum)
                          )
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.todayApplicationNum > 0,
                                expression: "item.todayApplicationNum>0"
                              }
                            ],
                            staticStyle: { "font-weight": "600", color: "red" }
                          },
                          [
                            _vm._v(
                              "   ( " +
                                _vm._s(_vm.language["emp.home.today"]) +
                                ":+" +
                                _vm._s(item.todayApplicationNum) +
                                " )"
                            )
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { marginBottom: "24px" },
              attrs: { sm: 24, md: 12, xl: 6 }
            },
            [
              _c(
                "a-card",
                {
                  attrs: {
                    title: _vm.language["common.sum"],
                    bordered: false,
                    "body-style": { padding: "20px 24px 8px" }
                  }
                },
                [
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.language["emp.home.contentTotalClickSize"]) +
                          ":  "
                      )
                    ]),
                    _c("span", { staticStyle: { "font-weight": "600" } }, [
                      _vm._v(_vm._s(_vm.contentTotalClickSize))
                    ])
                  ]),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.language["emp.home.contentTodayClickSize"]) +
                          ":  "
                      )
                    ]),
                    _c("span", { staticStyle: { "font-weight": "600" } }, [
                      _vm._v(_vm._s(_vm.contentTodayClickSize))
                    ])
                  ]),
                  _c("br"),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.language["emp.home.subscriptionsAppSize"]) +
                          ":  "
                      )
                    ]),
                    _c("span", { staticStyle: { "font-weight": "600" } }, [
                      _vm._v(_vm._s(_vm.subscriptionsAppSize))
                    ])
                  ]),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.language["emp.home.subscriptionsAppTodaySize"]
                        ) + ":   "
                      )
                    ]),
                    _c("span", { staticStyle: { "font-weight": "600" } }, [
                      _vm._v(_vm._s(_vm.subscriptionsAppTodaySize))
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }